enum UserVerificationMethod {
    EMAIL = 'email',
}

export default UserVerificationMethod;
